import { right } from 'fp-ts/Either';
import RichTextData from 'domain/entity/widgets/RichTextData';
import ReadWidgetDataClient from 'use-case/widgets/data/read/readWidgetDataClient';
import ReadWidgetDataCriteria from 'use-case/widgets/data/read/readWidgetDataCriteria';

const readProxyFrameDataApiClient: ReadWidgetDataClient = (criteria: ReadWidgetDataCriteria) =>
    Promise.resolve(right(new RichTextData(criteria.frameText)));

export default readProxyFrameDataApiClient;
